import { Warning, TrendUp } from "@phosphor-icons/react";
import { fmtDate, money } from "@/lib/api";
import { runwayDelta, deltaText } from "@/lib/scenarios";

export const ZeroCashCard = ({ kpis, impacts = [] }) => {
  const sfx = "";
  const testid = "zero-cash-card";
  const hasDate = !!kpis.zero_cash_date;
  return (
    <div data-testid={testid} className="relative overflow-hidden rounded-xl border border-[#9D00FF]/40 bg-[#121212] p-6">
      <div className="absolute -top-20 -right-20 h-48 w-48 rounded-full bg-[#9D00FF]/25 blur-3xl" />
      <p className="relative font-mono text-xs text-[#D9A6FF] flex items-center gap-2">
        {hasDate ? <Warning weight="fill" /> : <TrendUp />} ZERO CASH DATE
      </p>
      <p data-testid={`zero-cash-date${sfx}`} className="relative font-mono text-3xl md:text-4xl font-bold mt-3">
        {hasDate ? fmtDate(kpis.zero_cash_date) : "Not in 24 mo"}
      </p>
      <p data-testid={`runway-months${sfx}`} className="relative mt-2 text-sm text-[#A3A3A3]">
        {hasDate ? <><span className="font-mono text-white">{kpis.runway_months}</span> months of runway at current burn</> : "You're default alive on this forecast."}
      </p>
      {kpis.pipeline && (
        <p data-testid="pipeline-runway" className="relative mt-3 flex items-center gap-2 text-xs text-[#FF9FD6]">
          <span className="h-2 w-2 rounded-full bg-[#FF7AC6]" />
          With likely deals ({money(kpis.pipeline.weighted, true)}): {kpis.pipeline.zero_cash_date ? <span className="font-mono">{fmtDate(kpis.pipeline.zero_cash_date)}</span> : "not in 24 mo"}
        </p>
      )}
      {impacts.length > 0 && (
        <div data-testid={`scenario-impact${sfx}`} className="relative mt-5 space-y-2">
          {impacts.map((s) => {
            const d = runwayDelta(s, kpis.runway_months);
            return (
              <div key={s.id} className="rounded-lg border border-[#2A2A2A] bg-[#050505]/60 px-3 py-2 flex items-center gap-3">
                <span className="h-2.5 w-2.5 rounded-full shrink-0" style={{ background: s.color }} />
                <div className="flex-1 min-w-0">
                  <p className="text-xs truncate">{s.label}</p>
                  <p className="font-mono text-sm">{s.zero_cash_date ? fmtDate(s.zero_cash_date) : "Not in 24 mo"}</p>
                </div>
                <span className={`font-mono text-xs ${d >= 0 ? "text-[#00FF9D]" : "text-[#FF5C7A]"}`}>{deltaText(s, kpis.runway_months)}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
